import { FormSchema } from 'types/form-schema';
import { RequiredCredential } from 'types/required-credential';

/**
 * Extracts a heading and sub-heading from a required credential using the form schema.
 * @export
 * @param {RequiredCredential} requiredCredential
 * @param {FormSchema} formSchema
 * @return {*}  {{
 *   heading: string;
 *   subHeading: string;
 * }}
 */
export function getHeadingAndSubHeading(
  requiredCredential: RequiredCredential,
  formSchema: FormSchema,
): {
  heading: string;
  unjoinedHeadings: { propertyName: string; value: string }[];
  subHeading: string;
  unjoinedSubHeadings: { propertyName: string; value: string }[];
} {
  const heading = formSchema[requiredCredential.type].headings
    .map((heading) => {
      // @ts-expect-error: typing issue with credential.type union type
      const foundMatch = requiredCredential.matchingCriteria.find((match) => match.field === heading);
      return foundMatch?.value ?? '';
    })
    .join(' ');
  const subHeading = formSchema[requiredCredential.type].subHeadings
    .map((heading) => {
      // @ts-expect-error: typing issue with credential.type union type
      const foundMatch = requiredCredential.matchingCriteria.find((match) => match.field === heading);
      return foundMatch?.value ?? '';
    })
    .join(' ');

  const unjoinedHeadings = formSchema[requiredCredential.type].headings.map((heading) => {
    // @ts-expect-error: typing issue with credential.type union type
    const foundMatch = requiredCredential.matchingCriteria.find((match) => match.field === heading);
    return { propertyName: heading, value: foundMatch?.value ?? '' };
  });

  const unjoinedSubHeadings = formSchema[requiredCredential.type].subHeadings.map((subHeading) => {
    // @ts-expect-error: typing issue with credential.type union type
    const foundMatch = requiredCredential.matchingCriteria.find((match) => match.field === subHeading);
    return { propertyName: subHeading, value: foundMatch?.value ?? '' };
  });

  return {
    heading,
    subHeading,
    unjoinedHeadings,
    unjoinedSubHeadings,
  };
}
